import getColor from "@insite/mobius/utilities/getColor";
import { categoryListStyles } from "@waytek/Overrides/Widgets/Category/CategoryList";
import { fontFamily, mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

const localColors = {
    globalGuardianBlue: getColor("common.global.guardianBlue"),
    globalIndustrialTaupe: getColor("common.global.industrialTaupe")
};

categoryListStyles.container = {
    ...categoryListStyles.container,
    css: css`
        &&& {
            > div {
                width: calc(100% + 15px);
                margin-left: -7.5px;
            }
        }
    `,
};

categoryListStyles.innerContainer = {
    ...categoryListStyles.innerContainer,
    gap: 4,
    css: css`
        &&& {
            > div {
                display: flex;
                flex-direction: column;
                flex-wrap: nowrap;
                height: 100%;
            }
        }
    `,   
};

categoryListStyles.categoryImageItem = {
    ...categoryListStyles.categoryImageItem,
    css: css`
        border: 1px solid ${localColors.globalIndustrialTaupe};
        border-bottom: 0;
        justify-content: center;
        min-height: 210px;
        align-items: center;
        &&& {
            span {
                text-decoration: none;
                border-bottom: 0;
            }

            img {
                aspect-ratio: 4/3;
                object-fit: contain;
            }
        }
    `,
};

categoryListStyles.categoryNameLinkItem = {
    ...categoryListStyles.categoryNameLinkItem,
    css: css`
        border: 1px solid ${localColors.globalIndustrialTaupe};
        padding: 20px 25px;
        &&& {
            span {
                text-decoration: none;
                border-bottom: 0;

                &:hover {
                    text-decoration: underline;
                }
            }
        }
    `,
};

categoryListStyles.categoryName = {
    ...categoryListStyles.categoryName,
    fontFamily,
    css: css`
        font-size: 16px;
        color: ${localColors.globalGuardianBlue};
        font-weight: bold;
        text-decoration: none;
        border-bottom: 0;
    `,
};